import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ChatmessagesEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		id: yup.string().required().label("Id"),
		messageid: yup.string().required().label("Messageid"),
		body: yup.string().nullable().label("Body"),
		timestamp: yup.string().required().label("Timestamp"),
		type: yup.string().required().label("Type"),
		isread: yup.string().nullable().label("Isread"),
		createdat: yup.string().nullable().label("Createdat"),
		from_ph: yup.string().required().label("From Ph"),
		to_ph: yup.string().required().label("To Ph")
	});
	// form default values
	const formDefaultValues = {
		id: '', 
		messageid: '', 
		body: '', 
		timestamp: new Date(), 
		type: '', 
		isread: "((0))", 
		createdat: "(getutcdate())", 
		from_ph: '', 
		to_ph: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/chatmessages`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ChatmessagesEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Chatmessage"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="id"  onChange={formik.handleChange}  value={formik.values.id}   label="Id" type="text" placeholder="Enter Id"        className={inputClassName(formik?.errors?.id)} />
                                                <ErrorMessage name="id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Messageid *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="messageid"  onChange={formik.handleChange}  value={formik.values.messageid}   label="Messageid" type="text" placeholder="Enter Messageid"        className={inputClassName(formik?.errors?.messageid)} />
                                                <ErrorMessage name="messageid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Body 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="body"  onChange={formik.handleChange}  value={formik.values.body}   label="Body" type="text" placeholder="Enter Body"        className={inputClassName(formik?.errors?.body)} />
                                                <ErrorMessage name="body" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Timestamp *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="timestamp" value={formik.values.timestamp} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.timestamp)}        />
                                                <ErrorMessage name="timestamp" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Type *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="type"  onChange={formik.handleChange}  value={formik.values.type}   label="Type" type="text" placeholder="Enter Type"        className={inputClassName(formik?.errors?.type)} />
                                                <ErrorMessage name="type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Isread 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="isread"  onChange={formik.handleChange}  value={formik.values.isread}   label="Isread" type="text" placeholder="Enter Isread"        className={inputClassName(formik?.errors?.isread)} />
                                                <ErrorMessage name="isread" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                From Ph *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/from_ph_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="from_ph"     optionLabel="label" optionValue="value" value={formik.values.from_ph} onChange={formik.handleChange} options={response} label="From Ph"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.from_ph)}   />
                                                    <ErrorMessage name="from_ph" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                To Ph *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/from_ph_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="to_ph"     optionLabel="label" optionValue="value" value={formik.values.to_ph} onChange={formik.handleChange} options={response} label="To Ph"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.to_ph)}   />
                                                    <ErrorMessage name="to_ph" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ChatmessagesEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'chatmessages',
	apiPath: 'chatmessages/edit',
	routeName: 'chatmessagesedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ChatmessagesEditPage;
